import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AwakenModal } from 'src/app/shared/awaken-modal/awaken-modal.component';
import * as moment from 'moment';
import { MindbodyAppointmentsService } from 'src/app/providers/mindbody-appointments.service';

@Component({
  selector: 'a180-no-show-appointments',
  templateUrl: './no-show-appointments.component.html',
  styleUrls: ['./no-show-appointments.component.scss'],
})
export class NoShowAppointmentsComponent implements OnInit {
  @Input() noShowAppointments: any[] = [];
  @Input() updateAppointmentResponse: {appointment: any, message: {content: string, status: string}};
  noShowDates: string;
  emailOptions: { label: string, value: string }[];

  constructor(private modalCtrl: ModalController,
              private mindbodyAppointmentsService: MindbodyAppointmentsService) {
    this.emailOptions = [
      { label: 'First No-Show Warning - Fee Waived', value: 'fee_waived' },
      { label: 'Subsequent No-Show Warning - Fee Applied', value: 'fee_applied' },
      { label: 'Maintenance Appointment - No Fee', value: 'maintenance' },
      { label: 'Third Offense - Cancelled Upcoming Appointments', value: 'recurring' }
    ]
  }

  ngOnInit() {
    this.noShowDates = this.noShowAppointments.map(appt => moment(appt.start_date_time).format('MMM D, YYYY')).join(', ')
    console.log(this);
  };

  async emailOptionSelected(option: any) {
    const response = await this.confirmSelection(option)
    console.log(response);

    if (response === 'yes') {
      // const emailOption = option.includes('Fee Waived') ? 'fee_waived' : 'fee_applied'
      this.modalCtrl.dismiss({sendEmail: true, emailOption: option.value})
    }
  }

  async confirmSelection(option) {
    const modal  = await this.modalCtrl.create({
      component: AwakenModal,
      componentProps: {
        title: `You've selected: ${option.label}`,
        subtitle: 'Are you sure you want to send this email to the client?',
        type: 'confirm'
      },
      cssClass: 'small-modal'
    })
    await modal.present()
    const {data} = await modal.onDidDismiss()

    return data
  }
}
